import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useContext, useMemo } from "react";
import { Currency } from "@lookiero/sty-psp-locale";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const OrderRepo = OrderRepositoryImpl.getInstance();

const useGetReturningOrderPaymentBreakdown = (checkoutId: string, totalPrice: number, currency: Currency) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const initialData = useMemo(
    () => ({
      payment: {
        amount: 0,
        currency,
      },
      balance: {
        amount: 0,
        currency,
      },
    }),
    [currency],
  );

  const queryClient = useContext(queryClientContext);

  const { data } = useQuery(
    {
      queryKey: ["OrderPaymentBreakdown", auth, totalPrice],
      queryFn: async () => {
        if (totalPrice === undefined) {
          return initialData;
        }

        return await OrderRepo.getReturningOrderPaymentBreakdown(auth, checkoutId, totalPrice, currency, apiUrl);
      },
      enabled: Boolean(auth),
      placeholderData: keepPreviousData,
      initialData,
    },
    queryClient,
  );

  return data;
};

export { useGetReturningOrderPaymentBreakdown };
